export const renderResubscribeBanner = (
  featureFlag: boolean,
  transformTypeDecision: string
): boolean => {
  if (
    !featureFlag ||
    !transformTypeDecision ||
    transformTypeDecision !== 'AUTHENTICATED_NO_ACCESS'
  ) {
    return false
  }

  return true
}
